// A gateway onboarding accepted before the box was ever online is held by the
// gateway-manager, which parks a placeholder device in Connect straight away. That
// device reaches the customer's device list as an Emulate gateway that is not
// connected, but the gateway-manager has no gateway for it yet, so the gateway
// filter (`get_gateways_among_devices`) leaves it out. Once the box comes online the
// gateway-manager adopts that same device id and it becomes an ordinary gateway.

const EMULATE_GATEWAY_INTEGRATION = 'gateway_inv';

const isEmulateGatewayDevice = device =>
    [device.integration, device.manufacturer].some(value => typeof value === 'string' && value.startsWith(EMULATE_GATEWAY_INTEGRATION));

// Devices of this customer that are waiting for their gateway to come online. The api
// says so directly with `never_connected` (a placeholder not yet adopted by hardware);
// an api that predates the field falls back to "an Emulate gateway device, not
// connected, that the gateway-manager does not know yet".
export const waitingGatewayDevices = (devices, gatewayDeviceIds) =>
    devices.filter(device => {
        if (device.deleted || device.connected) {
            return false;
        }
        if (typeof device.never_connected === 'boolean') {
            return device.never_connected;
        }
        return isEmulateGatewayDevice(device) && !gatewayDeviceIds.includes(device.id);
    });

export const facilityAddress = (facilities, facilityId) => {
    const facility = (facilities || []).find(f => (f.facility_id || f.id) === facilityId);
    return facility?.address || '';
};
